import { Col, Row, Table } from "reactstrap";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function OveruseByContact(props) {
  //   console.log(props);
  const dispatch = useDispatch();

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const renderSubColumn = data => {
    const RowByData = () => {
      return data.contacts.map((contacts, index) => {
        return (
          <React.Fragment key={contacts}>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#7AE3F7",
                textAlign: "center",
                width: "20px",
                fontSize: "1.3vh",
              }}
            >
              Booking
            </th>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#7AE3F7",
                textAlign: "center",
                width: "20px",
                fontSize: "1.3vh",
              }}
            >
              Actual
            </th>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#7AE3F7",
                textAlign: "center",
                width: "1.7vh",
                fontSize: "1.3vh",
              }}
            >
              Overuse
            </th>
          </React.Fragment>
        );
      });
    };
    const RowByDummy = () => {
      let dummyList = [];
      if (props.contactCount != data.contacts.length) {
        let diff = props.contactCount - data.contacts.length;
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <th
              style={{
                backgroundColor: "#466597",
                color: "#FEF6AA",
                textAlign: "center",
                width: "20px",
                fontSize: "1.5vh",
                fontWeight: "bold",
              }}
            ></th>
            <th
              style={{
                backgroundColor: "#466597",
                color: "#FEF6AA",
                textAlign: "center",
                width: "20px",
                fontSize: "1.5vh",
                fontWeight: "bold",
              }}
            ></th>
            <th
              style={{
                backgroundColor: "#466597",
                color: "#FEF6AA",
                textAlign: "center",
                width: "20px",
                fontSize: "1.5vh",
                fontWeight: "bold",
              }}
            ></th>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        <RowByData />
        <RowByDummy />
      </>
    );
  };

  const renderTotalByRow = (data, item) => {
    // console.log(data);
    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data.map((value, index) => {
      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;
      total += value.OVERUSE;
    });
    const Total = () => {
      return data
        .sort((a, b) =>
          a.PRIORITY_FLAG > b.PRIORITY_FLAG
            ? 1
            : b.PRIORITY_FLAG > a.PRIORITY_FLAG
            ? -1
            : 0
        )
        .map((value, index) => {
          return (
            <React.Fragment key={index.toString()}>
              <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                <p>{numberFormat(value.OVERUSE_BOOKING , 0)}</p>
              </td>
              <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                <p>{numberFormat(value.OVERUSE_ACTUAL , 0)}</p>
              </td>
              <td
                style={{
                  ...((value.OVERUSE ).toFixed(0) > 0
                    ? {
                        color: "#FF4545",
                      }
                    : { color: "#FFFFFF" }),
                  fontWeight: "bold",
                  fontSize: "1.3vh",
                }}
              >
                <p>{numberFormat(value.OVERUSE , 0)}</p>
              </td>
            </React.Fragment>
          );
        });
    };
    const RowByDummy = () => {
      let dummyList = [];
      if (props.contactCount != item.contacts.length) {
        let diff = props.contactCount - item.contacts.length;
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <td></td>
            <td></td>
            <td></td>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        {/* <Total />
        <RowByDummy /> */}
        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
          <p>{numberFormat(totalBooking , 0)}</p>
        </td>
        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
          <p>{numberFormat(totalActual , 0)}</p>
        </td>
        <td
          style={{
            ...((total ).toFixed(0) > 0
              ? { color: " #FF4545" }
              : { color: "#FFFFFF" }),
            fontWeight: "bold",
            fontSize: "1.3vh",
          }}
        >
          <p>{numberFormat(total , 0)}</p>
        </td>
        {/* //rgb(240, 20, 6) */}
      </>
    );
  };
  const DummyContact = item => {
    let dummyList = [];
    if (props.contactCount != item.contacts.length) {
      let diff = props.contactCount - item.contacts.length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <th
            colSpan={3}
            style={{
              backgroundColor: "#556ee678",
              color: "#7AE3F7",
              textAlign: "center",
              fontSize: "1.3vh",
            }}
          ></th>
        </React.Fragment>
      );
    });
  };
  const DummyData = item => {
    let dummyList = [];
    if (props.contactCount != item.length) {
      let diff = props.contactCount - item.length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <td></td>
          <td></td>
          <td></td>
        </React.Fragment>
      );
    });
  };
  const OveruseByContact = (data, contacts) =>
    contacts.map((contact, index) => {
      let dataByContact = data.find(obj => obj.OVERUSE_CONTACTCODE == contact);
      if (dataByContact) {
        return (
          <React.Fragment key={dataByContact.PID}>
            <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
              <p>{numberFormat(dataByContact.OVERUSE_BOOKING , 0)}</p>
            </td>
            <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
              <p>{numberFormat(dataByContact.OVERUSE_ACTUAL , 0)}</p>
            </td>
            <td
              style={{
                ...((dataByContact.OVERUSE ).toFixed(0) > 0
                  ? { color: "#FF4545" }
                  : { color: "#FFFFFF" }),
                fontWeight: "bold",
                fontSize: "1.3vh",
              }}
            >
              <p>{numberFormat(dataByContact.OVERUSE , 0)}</p>
            </td>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index.toString()}>
            <td></td>
            <td></td>
            <td></td>
          </React.Fragment>
        );
      }
    });
  const renderOveruseData = (data, contact) => {
    // console.log(data);
    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data = data.sort((a, b) =>
      a.OVERUSE_CONTACTCODE > b.OVERUSE_CONTACTCODE
        ? 1
        : b.OVERUSE_CONTACTCODE > a.OVERUSE_CONTACTCODE
        ? -1
        : 0
    );
    data.map(value => {
      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;
      total += value.OVERUSE;
    });
    // console.log(data)
    return (
      <React.Fragment>
        {/* {OveruseByContact(data, contact)} */}
        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
          <p>{numberFormat(totalBooking , 0)}</p>
        </td>
        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
          <p>{numberFormat(totalActual , 0)}</p>
        </td>
        <td
          style={{
            ...((total ) > 0
              ? { color: "#FF4545" }
              : { color: "#FFFFFF" }),
            fontWeight: "bold",
            fontSize: "1.3vh",
          }}
        >
          <p>{numberFormat(total , 0)}</p>
        </td>
      </React.Fragment>
    );
  };
  return (
    <Row className="mt-1">
      <Col lg="12">
        {/* <div
          style={{ position: "relative", overflowY: "auto", maxHeight: "97%" }} height: 69vh
        > */}
          <div className="table-responsive"  style={{ position: "relative", overflowY: "auto", maxHeight: "64vh" }}>
            <Table className="table table-bordered table-striped mb-0">
              {/* table-bordered */}
              {/* table-dark */}
              {props.overuseData.map(item => {
                return (
                  <React.Fragment key={item.SHIPPER_NAME}>
                    <thead>
                      {/* <tr>
                      <th
                        colSpan={props.contactCount * 3 + 4}
                        style={{
                          backgroundColor: "#466597",
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "100%",
                          fontSize: "1.3vh",
                        }}
                      >
                        {item.SHIPPER_NAME}
                      </th>
                    </tr> */}
                      <tr>
                        <th
                          rowSpan={3}
                          style={{
                            backgroundColor: "#466597",
                            color: "#FEF6AA",
                            textAlign: "center",
                            fontSize: "1.5vh",
                            fontWeight: "bold",
                            width: "2vw",
                          }}
                        >
                          Area
                        </th>
                      </tr>

                      {/* <tr> */}

                        {/* {item.contacts.map((contact, index) => {
                        return (
                          <th
                            key={contact}
                            colSpan={3}
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "#5868b785" : "#667eef85",
                              color: "#FEF6AA",
                              textAlign: "center",
                              fontSize: "1.3vh",
                            }}
                          >
                            {contact}
                          </th>
                        );
                      })} */}
                        {/* {DummyContact(item)} */}

                        {/* <th
                          colSpan={3}
                          style={{
                            backgroundColor: "#466597",
                            color: "#FEF6AA",
                            textAlign: "center",
                            fontSize: "1.5vh",
                            fontWeight: "bold",
                          }}
                        >
                          Total
                        </th> */}

                      {/* </tr> */}
                      
                      <tr>
                        {/* {renderSubColumn(item)} */}
                        <th
                          style={{
                            backgroundColor: "#466597",
                            color: "#FEF6AA",
                            textAlign: "center",
                            width: "20px",
                            fontSize: "1.5vh",
                            fontWeight: "bold",
                          }}
                        >
                          Booking
                        </th>
                        <th
                          style={{
                            backgroundColor: "#466597",
                            color: "#FEF6AA",
                            textAlign: "center",
                            width: "20px",
                            fontSize: "1.5vh",
                            fontWeight: "bold",
                          }}
                        >
                          Actual
                        </th>
                        <th
                          style={{
                            backgroundColor: "#466597",
                            color: "#FEF6AA",
                            textAlign: "center",
                            width: "20px",
                            fontSize: "1.5vh",
                            fontWeight: "bold",
                          }}
                        >
                          Overuse
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      style={{
                        color: "#FFFFFF",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {item.entry.map(obj => {
                        let totalBooking = 0;
                        let totalActual = 0;
                        let total = 0;
                        return (
                          <tr key={obj.OVERUSE_AREA}>
                            <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                              {obj.OVERUSE_AREA}
                            </td>
                            {renderOveruseData(obj.data, item.contacts)}
                          </tr>
                        );
                      })}

                      <tr style={{ backgroundColor: "#556ee630" }}>
                        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                          Total
                        </td>
                        {renderTotalByRow(item.entryTotal, item)}
                      </tr>
                      {item.exit.map(obj => {
                        let totalBooking = 0;
                        let totalActual = 0;
                        let total = 0;
                        return (
                          <tr key={obj.OVERUSE_AREA}>
                            <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                              {obj.OVERUSE_AREA}
                            </td>
                            {renderOveruseData(obj.data, item.contacts)}
                          </tr>
                        );
                      })}
                      <tr style={{ backgroundColor: "#556ee630" }}>
                        <td style={{ fontSize: "1.3vh", color: "#FFFFFF" }}>
                          Total
                        </td>
                        {renderTotalByRow(item.exitTotal, item)}
                      </tr>
                    </tbody>
                  </React.Fragment>
                );
              })}
            </Table>
          {/* </div> */}
        </div>
      </Col>
    </Row>
  );
}

OveruseByContact.propTypes = {
  t: PropTypes.any,
  overuseData: PropTypes.any,
  shipper: PropTypes.any,
  contactCount: PropTypes.any,
};

export default OveruseByContact;
